import { render, staticRenderFns } from "./CloseDialog.vue?vue&type=template&id=7a52c2dc&"
import script from "./CloseDialog.vue?vue&type=script&lang=js&"
export * from "./CloseDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports